export const getOrderedMedicalSupplies = ({ medicines }) => {
  return medicines?.filter(
    (medicine) =>
      !!medicine?.category && medicine?.category === "Medical Supply"
  )
}
